import React from "react";
import { observer } from 'mobx-react';
import { observable } from 'mobx';

export default @observer class Canvas extends React.Component {
  mouseX = undefined;
  mouseY = undefined;

  @observable width = 0;
  @observable height = 0;
  @observable canvasWidth = 0;
  @observable canvasHeight = 0;

  constructor(props) {
    super(props);

    this.canvas = React.createRef();

    this.getCanvas = this.getCanvas.bind(this);
    this.getContext = this.getContext.bind(this);

    this.width = this.props.width || 100;
    this.height = this.props.height || 100;

  }

  componentDidUpdate() {
    this.notifyUpdate();
  }

  componentWillMount() {
    this.canvasWidth =
      this.width +
      (this.customs && this.customs.padding
        ? this.customs.padding.left + this.customs.padding.right
        : 0);
    this.canvasHeight =
      this.height +
      (this.customs && this.customs.padding
        ? this.customs.padding.top + this.customs.padding.bottom
        : 0);

    if(this.props.className) {
      this.canvasWidth = null;
      this.canvasHeight = null;
    }
  }

  componentDidMount() {
    this.bounds = this.getCanvas().getBoundingClientRect();
    this.offsetX = this.bounds.x;
    this.offsetY = this.bounds.y;

    if(this.props.className) {

      // const bounds = this.refs.canvasContainer.getBoundingClientRect();
      this.height = 0;
      this.width = 0;

      // this.canvasWidth = bounds.width;
      // this.canvasHeight = bounds.height;
      // this.width = this.canvasWidth - (this.customs && this.customs.padding ? this.customs.padding.left + this.customs.padding.right : 0);
      // this.height = this.canvasHeight - (this.customs && this.customs.padding ? this.customs.padding.top + this.customs.padding.bottom : 0)
    }

    // console.log(this.bounds);

    // undo / redo :D
    this.history = {
      redo_list: [],
      undo_list: [],
      saveState: arr => {
        this.history.undo_list.push(arr);
      },
      undo: () => {
        if (this.history.undo_list.length) this.history.restoreState();
      },
      redo: () => {
        // TODO
      },
      restoreState: () => {
        var restore_state = this.history.undo_list.pop();
        this.setObjects(restore_state[0]);
        this.onHistoryRestored(restore_state);
        this.notifyUpdate();
      }
    };

    this.objects = [];
    this.hiddenObjects = [];

    this.onInit();
    this.__idk();
    this.onDraw();
  }

  onHistoryRestored(objects) {}

  onUpdate() {
    this.bounds = this.getCanvas().getBoundingClientRect();
    this.offsetX = this.bounds.x;
    this.offsetY = this.bounds.y;
  }

  xCoord(coord) {
    return coord + this.customs.padding.left;
  }

  yCoord(coord) {
    return coord + this.customs.padding.top;
  }

  getCanvas() {
    return this.canvas.current;
  }

  getContext() {
    if (!this._context) this._context = this.getCanvas().getContext("2d");
    return this._context;
  }

  normalizeObject(obj) {
    if (obj.draggable) {
      obj.dragging = false;
      obj.on("mousedown", e => {
        let x = e.clientX,
          y = e.clientY;
        obj.isDragging = true;
        obj.dragStart = { x, y };
      });
    }
    // offset the x and y of object
    if (this.customs && this.customs.padding && !obj.restored && !obj.hasFlag('skipMeFromPadding')) {
      obj.x += this.customs.padding.left;
      obj.y += this.customs.padding.top;

      if (obj.constraints) {
        let cons = obj.constraints;
        cons.maxX += this.customs.padding.left;
        cons.maxY += this.customs.padding.top;
        cons.minX += this.customs.padding.left;
        cons.minY += this.customs.padding.top;
        obj.constraints = cons;
      }
    }
  }

  __idk() {
    // get all objects
    for (let obj of this.objects) {
      if (obj.draggable) {
        obj.dragging = false;
        obj.on("mousedown", e => {
          let x = e.clientX,
            y = e.clientY;
          obj.isDragging = true;
          obj.dragStart = { x, y };
        });
      }
      // offset the x and y of object
      if (this.customs && this.customs.padding && !obj.restored && !obj.hasFlag('skipMeFromPadding')) {
        obj.x += this.customs.padding.left;
        obj.y += this.customs.padding.top;

        if (obj.constraints) {
          let cons = obj.constraints;
          cons.maxX += this.customs.padding.left;
          cons.maxY += this.customs.padding.top;
          cons.minX += this.customs.padding.left;
          cons.minY += this.customs.padding.top;
          obj.constraints = cons;
        }
      }
    }

    this.getCanvas().addEventListener("mousedown", this.onMouseDown.bind(this));
    this.getCanvas().addEventListener("mousemove", this.onMouseMove.bind(this));
    this.getCanvas().addEventListener("mouseout", this.onMouseOut.bind(this));
    this.getCanvas().addEventListener("mouseup", this.onMouseUp.bind(this));

    window.addEventListener('keydown', this.onKeyDown.bind(this), false);

    this.getCanvas().addEventListener(
      "dblclick",
      this.onDoubleClick.bind(this)
    );
  }

  onKeyDown(e) {
    if(this.isFocused)
      this.objects.forEach(obj => {
        obj.callEvent("keydown", e);
      });
  }

  remove(obj) {
    const index = this.objects.indexOf(obj);
    if (index < 0) return;
    const removed = this.objects.splice(index, 1);
    this.onObjectRemoved(removed[0]);
  }

  onObjectRemoved(removed) {
    this.notifyUpdate();
  }

  onDoubleClick(e) {
    e.preventDefault();
    let x = this.mouseX,
      y = this.mouseY;
    let object = this.getObjAt(x, y, true);
    if (object) {
      object.callEvent("dbclick", e);
    } else {
      this.onCanvasDoubleClick(e);
    }
  }

  onMouseDown(e) {
    e.preventDefault();
    let x = this.mouseX,
      y = this.mouseY;

    let object = this.getObjAt(x, y, true);

    // unfocus all objects
    this.objects.forEach(obj => {
      obj.focused = false;
      obj.callEvent("unfocus", e, object);
    });

    if (object) {
      this.onObjectStartMove(object);
      object.callEvent("mousedown", e);
      object.focused = true;
      object.callEvent("focus", e);
    } else {
      e.mouseX = this.mouseX;
      e.mouseY = this.mouseY;
      this.onCanvasClick(e);
    }
  }

  onCanvasClick(e) {}
  onCanvasDoubleClick(e) {}
  onObjectStartMove(object) {}

  addObject(...objs) {
    objs.forEach(obj => {
      this.normalizeObject(obj);
      this.objects.push(obj);
    });
    this.notifyUpdate();
  }

  removeObjects(...objs) {
    objs.forEach(obj => {
      const index = this.objects.indexOf(obj);
      if(index > -1)
        this.objects.splice(index, 1);
    });
    this.notifyUpdate();
  }

  copyArray(old) {
    const newA = new Array(old.length);
    for (let o of old) {
      let i = old.indexOf(o);
      newA[i] = Object.assign({}, o);
    }
    return newA;
  }

  setObjects(newObjects) {
    const array = [];
    for (let obj of newObjects) {
      const exists = this.objects.find(o => o.id === obj.id);
      if (!exists) {
        array.push(obj);
      } else {
        // Obj does exists, update its state
        let tisObj = this.objects[this.objects.indexOf(exists)];
        array.push(tisObj.setState(obj));
      }
    }
    this.objects = array;
    this.notifyUpdate();
  }

  onMouseMove(e) {
    e.preventDefault();
    if(!this.isFocused) this.isFocused = true;
    // "Normalize"  the coords
    this.mouseX = e.clientX - this.offsetX;
    this.mouseY = e.clientY - this.offsetY;
    // console.log(e.clientX, e.clientY, this.offsetX, this.offsetY);
    // e.stopPropagation();
    for (let obj of this.objects) {
      if (obj.isDragging) {
        obj.updatePosition(this.mouseX, this.mouseY);
      }
    }
    this.notifyUpdate();
  }

  onMouseOut(e) {
    if(this.isFocused)
      this.isFocused = false;
    this.onMouseUp(e);
  }

  onMouseUp(e) {
    for (let obj of this.objects) {
      if (obj.isDragging) {
        obj.isDragging = false;
        obj.callEvent('mouseup', e);
      }
    }
  }

  findNearObjects(x, y, amount) {
    // var d = obj => obj.x * obj.x/* + obj.y * obj.y*/;

    const objects = this.objects.filter(i => this.hiddenObjects.indexOf(i) < 0);
    let origin = { x };

    let nearest = null;
    var minDist = null;
    for (var i = 0; i < objects.length; i++) {
      let obj = objects[i];
      if(obj.hasFlag('skipMeForNearObjs')) continue;
      let dist = Math.abs(origin.x - obj.x);
      if(minDist === null || dist <= minDist) {
        minDist = dist;
        nearest = obj;
      }
    }

    return [nearest];
  }

  nearestPoint(x, y) {
    x += this.customs ? this.customs.padding.left : 0;
    const nearest = this.findNearObjects(x, y, 1)[0];
    const dir = nearest.x - x < 0 ? "left" : "right";

    return { obj: nearest, dir };
  }

  getObjAt(x, y, draggablePreffered) {
    const found = this.objects.filter(obj => {
      let boundingBox = obj.getBoundingBox();
      return boundingBox.has(x, y) && !this.isHidden(obj);
    });
    if (!found || found.length === 0) return null;
    if (found.length === 1) return found[0];
    else {
      // search for preffered first
      let preffered = [];
      if (draggablePreffered) {
        found.forEach(el => {
          if (el.draggable) preffered.push(el);
        });
        if (preffered.length === 0) preffered = found;
      } else {
        preffered = found;
      }

      // search for biggest size first
      let mostSize;
      let biggest;
      preffered.forEach(el => {
        let size = el.getSize();
        if (!mostSize || size >= mostSize) {
          mostSize = size;
          biggest = el;
        }
      });
      return biggest;
    }
  }

  // ========================= DRAWING METHODS ========================= //

  // --- Called once on first setup
  onInit() {}

  // --- Drawing method called after each update to the canvas
  onDraw() {
    for (let obj of this.objects) {
      if (!this.isHidden(obj)) obj.draw(this.getContext());
    }
  }

  isHidden(obj) {
    return this.hiddenObjects.indexOf(obj) !== -1;
  }

  hide(...objs) {
    objs.forEach(obj => {
      if (!this.isHidden(obj)) {
        this.hiddenObjects.push(obj);
      }
    });
    this.notifyUpdate();
  }

  show(...objs) {
    objs.forEach(obj => {
      let index = this.hiddenObjects.indexOf(obj);
      if (index !== -1) {
        this.hiddenObjects.splice(index, 1);
      }
    });
    this.notifyUpdate();
  }

  notifyUpdate() {
    this.onDraw();
  }

  resetStyles() {
    this.getContext().fillStyle = "#00000000";
    this.getContext().strokeStyle = "#00000000";
    this.getContext().lineWidth = "1";
  }

  // --- Colors, Styles and Shadows

  background() {
    let args = arguments;
    if (args.length === 0) return this.getCanvas().style.background;
    else if (args.length === 1) {
      let color = args[0];
      if (typeof color === "string")
        return (this.getCanvas().style.background = color);
      this.getCanvas().style.background = `rgb(${color},${color},${color})`;
    } else {
      let red = args[0];
      let green = args[1];
      let blue = args[2];
      let alpha = args[3] || 1;
      this.getCanvas().style.background = `rgba(${red},${green},${blue},${alpha})`;
    }
  }

  colorFunc(prop, args) {
    if (args.length === 0) return this.getContext()[prop];
    else if (args.length === 1) {
      let color = args[0];
      if (typeof color === "string") return (this.getContext()[prop] = color);
      this.getContext()[prop] = `rgb(${color},${color},${color})`;
    } else {
      let red = args[0];
      let green = args[1];
      let blue = args[2];
      this.getContext()[prop] = `rgb(${red},${green},${blue})`;
    }
  }

  fill() {
    this.colorFunc("fillStyle", arguments);
    this.getContext().fill();
    this.end();
  }

  noFill() {
    this.colorFunc("fillStyle", "#00000000");
  }

  stroke() {
    this.colorFunc("strokeStyle", arguments);
    this.getContext().stroke();
    this.end();
  }

  noStroke() {
    this.colorFunc("strokeStyle", "#00000000");
  }

  shadow(color) {
    if (!color) return this.getContext().shadowColor;
    this.getContext().shadowColor = color;
  }

  clear() {
    this.getContext().resetTransform();
    this.getContext().clearRect(
      0,
      0,
      this.getCanvas().width,
      this.getCanvas().height
    );
  }

  // =============

  linearGradient() {
    return this.contextFunc('createLinearGradient', arguments);
  }

  pattern() {
    return this.contextFunc('createPattern', arguments);
  }

  radialGradient() {
    return this.contextFunc('createRadialGradient', arguments);
  }



  lineCap() {
    return this.contextFunc('lineCap', arguments);
  }

  lineJoin() {
    return this.contextFunc('lineJoin', arguments);
  }

  strokeWidth() {
    return this.contextFunc('lineWidth', arguments);
  }

  miterLimit() {
    return this.contextFunc('miterLimit', arguments);
  }



  rect() {
    this.begin();
    return this.contextFunc('rect', arguments);
  }

  strokeRect() {
    this.begin();
    return this.contextFunc('strokeRect', arguments);
  }



  moveTo() {
    return this.contextFunc('moveTo', arguments);
  }

  lineTo() {
    return this.contextFunc('lineTo', arguments);
  }

  clip() {
    return this.contextFunc('clip', arguments);
  }

  quadraticCurveTo() {
    this.begin();
    return this.contextFunc('quadraticCurveTo', arguments);
  }

  bezierCurveTo() {
    this.begin();
    return this.contextFunc('bezierCurveTo', arguments);
  }

  arc() {
    this.begin();
    return this.contextFunc('arc', arguments);
  }

  arcTo() {
    this.begin();
    return this.contextFunc('arcTo', arguments);
  }

  circle(x, y, radius) {
    this.arc(x, y, radius, 0, 2 * Math.PI);
  }

  isPointInPath() {
    return this.contextFunc('isPointInPath', arguments);
  }



  scale() {
    this.saveCtx();
    return this.contextFunc('scale', arguments);
  }

  rotate() {
    this.saveCtx();
    return this.contextFunc('rotate', arguments);
  }

  translate() {
    this.saveCtx();
    return this.contextFunc('translate', arguments);
  }

  transform() {
    this.saveCtx();
    return this.contextFunc('transform', arguments);
  }

  setTransform() {
    this.saveCtx();
    return this.contextFunc('setTransform', arguments);
  }



  textFont() {
    return this.contextFunc('font', arguments);
  }

  textAlign() {
    return this.contextFunc('textAlign', arguments);
  }

  textBaseline() {
    return this.contextFunc('textBaseline', arguments);
  }



  text() {
    return this.contextFunc('fillText', arguments);
  }

  strokeText() {
    return this.contextFunc('strokeText', arguments);
  }

  getTextWidth() {
    return this.contextFunc('measureText', arguments);
  }



  image() {
    return this.contextFunc('drawImage', arguments);
  }

  imageData() {
    return this.contextFunc('createImageData', arguments);
  }

  getImageData() {
    return this.contextFunc('getImageData', arguments);
  }

  putImageData() {
    return this.contextFunc('putImageData', arguments);
  }



  globalAlpha() {
    return this.contextFunc('globalAlpha', arguments);
  }

  compositeOperation() {
    return this.contextFunc('globalCompositeOperation', arguments);
  }

  // useful function
  contextFunc(prop, args) {
    if(args.length === 0) return this.getContext()[prop];
    else {
      if(typeof this.getContext()[prop] === 'function') {
        return this.getContext()[prop].apply(this.getContext(), args);
      } else {
        const value = args[0];
        return this.getContext()[prop] = value;
      }
    }
  }

  // begin and end

  closePath() {
    this.getContext().closePath();
  }

  saveCtx() {
    if(!this.saved) {
      this.getContext().save();
      this.saved = true;
    }
  }

  begin() {
    this.saveCtx();
    this.getContext().beginPath();
  }

  end() {
    if(this.saved) {
      this.getContext().restore();
      this.saved = false;
    }
  }

  onRender() {}

  render() {
    return (
      <div className={this.props.className} ref='canvasContainer' >
        <canvas
          ref={this.canvas}
          width={this.canvasWidth}
          height={this.canvasHeight}
        />
        {this.onRender()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/canvas/Canvas.js